export default __webpack_public_path__ + "static/media/email.dfa085b8.png";